/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetFnsInn200ResponseDataInner } from './GetFnsInn200ResponseDataInner'
import {
  GetFnsInn200ResponseDataInnerFromJSON,
  GetFnsInn200ResponseDataInnerFromJSONTyped,
  GetFnsInn200ResponseDataInnerToJSON,
} from './GetFnsInn200ResponseDataInner'

/**
 *
 * @export
 * @interface GetFnsInn200Response
 */
export interface GetFnsInn200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetFnsInn200Response
   */
  status: boolean
  /**
   *
   * @type {Array<GetFnsInn200ResponseDataInner>}
   * @memberof GetFnsInn200Response
   */
  data: Array<GetFnsInn200ResponseDataInner>
}

/**
 * Check if a given object implements the GetFnsInn200Response interface.
 */
export function instanceOfGetFnsInn200Response(
  value: object
): value is GetFnsInn200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetFnsInn200ResponseFromJSON(json: any): GetFnsInn200Response {
  return GetFnsInn200ResponseFromJSONTyped(json, false)
}

export function GetFnsInn200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetFnsInn200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(
      GetFnsInn200ResponseDataInnerFromJSON
    ),
  }
}

export function GetFnsInn200ResponseToJSON(
  value?: GetFnsInn200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(
      GetFnsInn200ResponseDataInnerToJSON
    ),
  }
}
